// extracted by mini-css-extract-plugin
export var productImage = "_lx-1";
export var viewLink = "_lx-2";
export var wishlistItem = "_lx-0";